import { FIND_A_PRO_RESULTS_PAGENAME } from "@/components/FindAProResults/v1/utils"
import { PRESS_KIT_PAGE_TYPE } from "@/constants/index"

export const isPageNameFindAProResults = pageType => {
  return FIND_A_PRO_RESULTS_PAGENAME.includes(pageType)
}

export const isPressKitPageType = pageType => pageType === PRESS_KIT_PAGE_TYPE
